<template>
  <div class="modal" @mousedown.self="closeSubsModal">
    <div class="modal-dialog modal-dialog-lg">
      <div class="modal-title"><span></span><span class="modal-close" @click="closeSubsModal"><i class="icon-close"></i></span></div>
      <div class="modal-content">
        <div class="content-block-title mb-1">Account</div>
          <div class="text-bold text-md mb-3">{{ userEmail }}</div>
          <div class="content-block-title mb-1">Your subscription plan</div>
          <div class="subscription-list">
            <div class="subscription" v-if="!customer && !isPremium">
              <div class="subscription-info">
                <div class="subscription-status">
                  <span class="subscription-status-label">Status: </span>
                  <span class="subscription-status-info warning">don’t have premium subsription</span>
                </div>
              </div>
            </div>
            <div v-if="customer">
              <div :key="item.id" v-for="(item, index) in subs" v-bind:value="item" class="subscription" v-show="item.status === 'active' || showAll || index === 0">
              <div class="subscription-info">
                <div class="subscription-status">
                  <span class="subscription-status-label">Status: </span>
                  <span class="subscription-status-info" :class="item.status">{{ item.status }}</span>
                </div>
                <div class="text-lg text-bold">{{ item.plan.interval }} subscription</div>
              </div>
              <div class="subscription-period">
                {{ convertDate(item.current_period_start) }} - {{ convertDate(item.current_period_end) }}
              </div>
              <div class="subscription-price text-lg text-bold">${{ item.plan.amount/100 }}</div>
              <button class="btn btn-secondary subscription-cancel" v-if="item.status === 'active'" v-on:click="cancel(item.id)">Cancel subscription</button>
            </div>
            </div>
          </div>
        <div class="subscription-controls flex-v-center flex-between mt-1" :class="{'flex-end': subs.some(item => item.status == 'active')}">
          <button v-if="!customer && !isPremium" class="btn btn-main" @click="getPremium">Get Premium</button>
          <button v-if="!subs.find(item => item.status === 'active')"  @click="getPremium" class="btn btn-main">Renew subscription</button>
          <span v-if="customer" @click="showAll = !showAll" class="text-bold pointer">{{showAll ? 'Hide history' : 'Payments history'}}</span>
        </div>
        </div>
      </div>
    </div>
</template>
<script>

import {API_HOST} from "@/helpers/stipe_const";
import {reportEvent} from "@/helpers/utils";

export default {
  name: 'Subscription',
  props: ['customer', 'userEmail', 'isPremium'],
  data() {
    return {
      showAll: false,
      subs: [],
      testPayment: localStorage.getItem('stripeTest'),
    }
  },
  watch: {
    customer: function (){
      this.getSubs()
    }
  },
  async mounted() {
    reportEvent('openUserSubscriptionPopup', {'email': this.userEmail})
    this.getSubs();
  },
  methods: {
    async cancel(id) {
      const cancelStatus = await fetch(`${API_HOST}/api/cancel-subscription?customerId=${this.customer.id}&subscriptionId=${id}${this.testPayment ? '&test=1' : ''}`, {}).then(r => r.json());
      if (cancelStatus) {
        reportEvent('cancelSubscription', {'email': this.userEmail})
        this.getSubs();
      }
    },
    async getSubs() {
      if (this.customer) {
        const subs = await fetch(`${API_HOST}/api/subscriptions?customerId=${this.customer.id}${this.testPayment ? '&test=1' : ''}`, {}).then(r => r.json());
        this.subs = subs.subscriptions ? subs.subscriptions.data : [];
      }
    },
    convertDate (unix_timestamp) {
      const date = new Date(unix_timestamp * 1000);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getUTCFullYear();

      const formattedTime = day + '/' + month + '/' + year;
      return formattedTime
    },
    closeSubsModal() {
      this.$emit('closesubsmodal');
    },
    getPremium () {
      this.closeSubsModal()
      this.$emit('getpremium');
    }
  },
}
</script>

<style lang="scss">
@import "../assets/styles/helpers";

.subscription {
  display: flex;
  justify-content: space-between;

  & + & {
    margin-top: 32px;
  }

  &-list {
    background: #F4F6F6;
    border-radius: 16px;
    padding: 18px 24px;
    position: relative;
  }

  &-period {
    display: flex;
    align-items: flex-end;
    font-size: 14px;
    color: #9797A0;
  }

  &-price {
    display: flex;
    align-items: flex-end;
  }

  &-controls {
    min-height: 52px;
  }

  &-cancel {
    position: absolute;
    bottom: -64px;
    left: 0;
  }

  &-status {
    font-size: 14px;

    &-label {
      color: #9797A0;
    }

    &-info {
      color: #ea2e22;

      &.active {
        color: #00c108;
      }

      &.warning {
        color: #d8ac27;
      }
    }
  }
}
</style>
